import { AccountGetResponse, AllFTUXes, initialFTUXDictionary } from '@aloft/toolkit-shared';
import { PayloadAction, Reducer, createSlice } from '@reduxjs/toolkit';

import { ToolkitAccount } from '../../controller/types.ts';
import { AccountState } from '../types.ts';
import { accountReqToState } from '../utils/accountReqToState.ts';

export const initialAccountState: AccountState = { mlsIDs: [], ftux: initialFTUXDictionary };

const accountSlice = createSlice({
  name: 'account',
  initialState: initialAccountState,
  reducers: {
    loadAccount(_, action: PayloadAction<AccountGetResponse>) {
      return accountReqToState(action.payload);
    },
    editAccountFormSubmit(state, action: PayloadAction<ToolkitAccount>) {
      // doing it this way to make it immediately clear what fields are even editable
      const { email, firstName, lastName, phone, mlsIDs } = action.payload;
      return {
        ...state,
        email,
        firstName,
        lastName,
        phone,
        mlsIDs,
      };
    },
    completeOnboardingForm(state, action: PayloadAction<ToolkitAccount>) {
      const { email, firstName, lastName, phone, mlsIDs, mcKissockData } = action.payload;
      return {
        ...state,
        email,
        firstName,
        lastName,
        phone,
        mlsIDs,
        isOnboardingComplete: true,
        mcKissockData,
      };
    },
    setFTUXCount(state, action: PayloadAction<{ key: keyof AllFTUXes; count: number }>) {
      return {
        ...state,
        ftux: {
          ...state.ftux,
          [action.payload.key]: action.payload.count,
        },
      };
    },
    bulkSetFTUXCounts(state, action: PayloadAction<Partial<AllFTUXes>[]>) {
      const ftuxes = { ...state.ftux };
      const updatedFTUXDictionary: AllFTUXes = action.payload.reduce(
        (acc, update) => ({
          ...acc,
          ...update,
        }),
        ftuxes,
      ) as AllFTUXes;

      return {
        ...state,
        ftux: updatedFTUXDictionary,
      };
    },
    clearAllFTUXCounts(state) {
      return {
        ...state,
        ftux: initialFTUXDictionary,
      };
    },
    setAccountSignatureBlobId(state, action: PayloadAction<string | undefined>) {
      return {
        ...state,
        signatureBlobId: action.payload,
      };
    },
  },
});

export const {
  loadAccount,
  editAccountFormSubmit,
  completeOnboardingForm,
  setFTUXCount,
  bulkSetFTUXCounts,
  setAccountSignatureBlobId,
} = accountSlice.actions;

export const accountReducer = accountSlice.reducer as Reducer<typeof initialAccountState>;
